import { APP_CODE, TENANT_ID } from '../enums/cacheEnum';
import WebStorage from './cache';

export const isPersonalApp = () => {
  const tenantId = WebStorage.get(TENANT_ID);
  return tenantId === '0';
};

export const isEnterpriseZhongQiYan = () => {
  const tenantId = WebStorage.get(TENANT_ID);
  return tenantId === '261';
};

export const isCommunityApp = () => {
  const tenantId = WebStorage.get(APP_CODE);
  return tenantId === 'shanshe-community';
};

export const getUrlControllerName = () => {
  return WebStorage.get(APP_CODE);
};
